import { serifStyles } from "@pathwright/blocks/src/ui/typography"
import styled from "styled-components"

export const StyledQuoteContainer = styled.div`
  min-width: 50%;

  .ql-editor,
  .ql-editor > p {
    text-align: center;
  }

  .ContentText {
    overflow: visible;
  }

  // Helps prevent side scroll bar
  .BlockText {
    overflow-x: hidden;
  }

  ${(p) =>
    p.blockStyles
      ? `
      .ql-editor,
      .ql-editor > p,
      .BlockText {
        color: ${p.blockStyles.styleAttributes.color};
      }
    `
      : ""}
`

export const QuoteAttributionWrapper = styled.div`
  .ContentText .BlockText,
  .ContentText .ql-editor {
    display: inline-block;
    min-width: ${(p) => (p.isEmpty ? "100px" : "auto")};
    position: relative;
    overflow: visible;
    ${serifStyles()}

    &::after {
      content: "—";
      position: absolute;
      left: -23px;
      top: 0;
    }
  }

  .ql-editor.ql-blank::before {
    min-width: 100px;
  }
`
